// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getConfirmPatientHasNoAllergyEndPoint = (patientId) =>
  `api/v1/patients/${patientId}/allergies/confirmnoallergy`

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getUnConfirmPatientHasNoAllergyEndPoint = (patientId) =>
  `api/v1/patients/${patientId}/allergies/unconfirmnoallergy`

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getMediaFileEndpoint = (patientId, fileId) => `api/v1/patients/${patientId}/mediafiles/${fileId}`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setMediaFileTagsEndpoint = (patientId, fileId) => `api/v1/patients/${patientId}/mediafiles/${fileId}`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientInfoEndpoint = (patientId) => `api/v1/patients/${patientId}`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getIDVerificationEndpoint = (patientId) => `api/v1/patients/${patientId}/identityverification`

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getDeleteRemarkEndpoint = (visitId, remarkId) => `api/v1/visits/${visitId}/remarks/${remarkId}`

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getProductsEndpoint = (category, usState, patientId) => {
  let url = `api/v1/products?category=${category}`

  if (usState) {
    url += `&stateCode=${usState}`
  }
  if (patientId) {
    url += `&PatientId=${patientId}`
  }

  return url
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const processVisitPrescriptionEndpoint = (visitId) => `api/v1/visits/${visitId}/prescriptions/items/bulk`

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPatientPastVisitEndpoint = (patientId) => `api/v1/patients/${patientId}/visits/past`
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitInfoEndpoint = (visitId) => `api/v1/visits/${visitId}`
export const methods = {
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  GET: 'GET',
}

export const apiErrorCodes = {
  PATIENT_NOT_FOUND: 'PatientNotFound',
  INTERNAL_SEVER_ERROR: 'InternalServerError',
  ICD_CODE_COUNT_NOT_VALID: 'IcdCodeCountNotValid',
  ICD_CODE_NOT_FOUND: 'IcdCodeNotFound',
  FILE_NOT_FOUND: 'FileNotFound',
  PERIOD_NOT_VALID: 'PeriodNotValid',
  FILE_TAG_NOT_VALID: 'FileTagNotValid',
  ID_VERIFICATION_NOT_FOUND: 'IdentityVerificationNotFound',
  ITEM_NOT_FOUND: 'ItemNotFound',
  ITEM_COUNT_NOT_VALID: 'ItemCountNotValid',
  ITEM_NOT_UNIQUE: 'ItemNotUnique',
  CREDIT_AMOUNT_NOT_VALID: 'CreditAmountNotValid',
  PHARMACY_PICKUP_NOT_ALLOWED: 'PharmacyPickupNotAllowed',
  PHARMACY_NOT_VALID: 'PharmacyNotValid',
  SHIPPING_ADDRESS_NOT_VALID: 'ShippingAddressNotValid',

  VISIT_NOT_FOUND: 'VisitNotFound',
  PHARMACY_NOT_FOUND: 'PharmacyNotFound',
  DRUG_OPTION_NOT_FOUND: 'DrugOptionNotFound',
  DURATION_DAYS_NOT_VALID: 'DurationDaysNotValid',
  EARLIEST_FILL_DATE_NOT_VALID: 'EarliestFillDateNotValid',
  SIGNATURE_NOT_VALID: 'SignatureNotValid',
  REFILLS_QUANTITY_NOT_VALID: 'RefillsQuantityNotValid',
}
